/* eslint-disable max-len */
import React from "react"

import theme from "@irati/ui/src/global/theme"

import BaseSvgIcon from "../Base"

const ShoppingCart = (props) => {
  return (
    <BaseSvgIcon fill={theme.colors.greys.white} {...props} viewBox="0 0 30 30">
      <g>
        <path
          d="M10.375 27.1875C11.4105 27.1875 12.25 26.348 12.25 25.3125C12.25 24.277 11.4105 23.4375 10.375 23.4375C9.33947 23.4375 8.5 24.277 8.5 25.3125C8.5 26.348 9.33947 27.1875 10.375 27.1875Z"
          fill="#21295C"
        />
        <path
          d="M22.5625 27.1875C23.598 27.1875 24.4375 26.348 24.4375 25.3125C24.4375 24.277 23.598 23.4375 22.5625 23.4375C21.527 23.4375 20.6875 24.277 20.6875 25.3125C20.6875 26.348 21.527 27.1875 22.5625 27.1875Z"
          fill="#21295C"
        />
        <path
          d="M5.95703 8.4375H26.9805L23.8867 19.2656C23.7763 19.6586 23.54 20.0045 23.2139 20.2501C22.8879 20.4956 22.4902 20.6274 22.082 20.625H10.8555C10.4473 20.6274 10.0496 20.4956 9.72358 20.2501C9.39754 20.0045 9.16116 19.6586 9.05078 19.2656L4.80859 4.42969C4.75253 4.2337 4.63412 4.06132 4.47129 3.93867C4.30847 3.81602 4.1101 3.74979 3.90625 3.75H1.9375"
          stroke="#21295C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </BaseSvgIcon>
  )
}

export default ShoppingCart
